module.exports = __webpack_public_path__ + "img/bg_rocket_launch_1920.24df5e3b.png";